import { render, staticRenderFns } from "./FormStep4.vue?vue&type=template&id=54ade352&scoped=true&"
import script from "./FormStep4.vue?vue&type=script&lang=js&"
export * from "./FormStep4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ade352",
  null
  
)

export default component.exports